import React from 'react'

const Delete = () => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.875 3.2085L11.5135 9.05647C11.4211 10.5506 11.375 11.2976 11.0005 11.8348C10.8153 12.1003 10.5769 12.3244 10.3004 12.4928C9.74122 12.8335 8.99275 12.8335 7.49574 12.8335C5.99682 12.8335 5.24734 12.8335 4.68778 12.4922C4.41113 12.3235 4.17267 12.099 3.98756 11.833C3.61318 11.295 3.56801 10.5469 3.47769 9.0507L3.125 3.2085" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M5.75 6.84521H9.25" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M6.625 9.13184H8.375" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M2.25 3.20817H12.75M9.86571 3.20817L9.46752 2.38668C9.20298 1.84099 9.07068 1.56814 8.84254 1.39798C8.79197 1.36023 8.73836 1.32665 8.6823 1.29758C8.42966 1.1665 8.12644 1.1665 7.52001 1.1665C6.89835 1.1665 6.58755 1.1665 6.3307 1.30307C6.27378 1.33334 6.21946 1.36828 6.16831 1.40752C5.93751 1.58458 5.80859 1.86741 5.55074 2.43307L5.19743 3.20817" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round"/>
</svg>

  )
}

export default Delete
